import React, { useContext as useContextCore, useState } from 'react'
import type { State } from '@ztechapps/common.hook'

export type ProviderProps = {
  recaptchaSiteKey: string
  url: string
  redirectUrl?: string
  children: React.ReactNode
}

export type ContextType = {
  destination: State<string>
  code: State<string>
  requestId: State<string>
  showCodeInput: State<boolean>
  userId: State<string>
  errorMessage: State<string>
} & Omit<ProviderProps, 'children'>

const context = React.createContext<ContextType>({} as ContextType)
const CoreProvider = context.Provider

export const Provider = ({ children, ...props }: ProviderProps) => {
  const destination = useState<string>('')
  const code = useState<string>('')
  const showCodeInput = useState<boolean>(false)
  const requestId = useState<string>('')
  const userId = useState<string>('')
  const errorMessage = useState<string>(null)

  return (
    <CoreProvider value={{ ...props, destination, code, showCodeInput, requestId, userId, errorMessage }}>
      {children}
    </CoreProvider>
  )
}

export const useContext = () => useContextCore(context)
